export const paramsHistoryKey = 'vsly_params_history'
export const visitedPagesKey = 'vsly_visited_pages'
